// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_UploadimagemperfilResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for uploadImagemPerfil endpoint.
 * Returns the public URL of the uploaded profile image.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Usuarios_UploadimagemperfilResponseDados = string;

export type Usuarios_UploadimagemperfilResponse = ApiResponse<Usuarios_UploadimagemperfilResponseDados>;

registerResponseContract('Usuarios_UploadimagemperfilResponse', {})
